module.exports = __webpack_public_path__ + "static/img/home_fiveScene_firstIllustration_img.c498cd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_fiveScene_firstIllustration_img.png
// module id = /NkX
// module chunks = 0